// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"261f0f21","453":"3d35e493"}[chunkId] + ".chunk.js";
};